<template>
  <div>
    <div class="kt-head kt-head--skin-light kt-head--fit-x kt-head--fit-b">
      <h3 class="kt-head__title">
        <div v-show="hasUnread" class="dropdown-toolbar-actions">
          <button class="btn btn-sm btn-ss btn-pill" @click.prevent="markAllRead">
            <i class="flaticon2-open-text-book" />Mark all as read
          </button>
          <br><br>
        </div>
        <span class="title">Notifications</span>
        <span class="btn btn-ss-label btn-sm btn-bold btn-font-md">{{ total }} new</span>
        <subscription />
      </h3>

      <ul class="nav nav-tabs nav-tabs-line nav-tabs-bold nav-tabs-line-3x nav-tabs-line-brand kt-notification-item-padding-x" role="tablist">
        <li class="nav-item">
          <a
            class="nav-link active show" data-toggle="tab"
            href="#topbar_notifications_alerts"
            role="tab" aria-selected="true">Alerts</a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link" data-toggle="tab"
            href="#topbar_notifications_events"
            role="tab" aria-selected="false">Events</a>
        </li>
        <li class="nav-item">
          <a
            class="nav-link" data-toggle="tab"
            href="#topbar_notifications_logs"
            role="tab" aria-selected="false">Logs</a>
        </li>
      </ul>
    </div>
    <div class="tab-content">
      <div id="topbar_notifications_alerts" class="toolbar-notifications-tab tab-pane active show" role="tabpanel">
        <div
          class="kt-notification kt-margin-t-10 kt-scroll" data-scroll="true"
          data-height="300"
          data-mobile-height="200">
          <ul>
            <notification
              v-for="notification in alerts"
              :key="notification.id"
              :notification="notification"
              @read="markAsRead(notification)" />
            <li v-if="!hasUnread" class="notification text-center">
              You don't have any unread notifications.
            </li>
          </ul>
        </div>
      </div>

      <div id="topbar_notifications_events" class="toolbar-notifications-tab tab-pane show" role="tabpanel">
        <div
          class="kt-notification kt-margin-t-10 kt-scroll"
          data-scroll="true"
          data-height="300"
          data-mobile-height="200">
          <ul>
            <notification
              v-for="notification in events"
              :key="notification.id"
              :notification="notification"
              @read="markAsRead(notification)" />
            <li v-if="!hasUnread" class="notification text-center">
              You don't have any unread notifications.
            </li>
          </ul>
        </div>
      </div>

      <div id="topbar_notifications_logs" class="toolbar-notifications-tab tab-pane show" role="tabpanel">
        <div
          class="kt-notification kt-margin-t-10 kt-scroll"
          data-scroll="true"
          data-height="300"
          data-mobile-height="200">
          <ul>
            <notification
              v-for="notification in logs"
              :key="notification.id"
              :notification="notification"
              @read="markAsRead(notification)" />
            <li v-if="!hasUnread" class="notification text-center">
              You don't have any unread notifications.
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Notification from "VueComponents/Notification";
import Subscription from "VuePartials/Subscription";
export default {
  components: { Notification, Subscription },

  data: () => ({
    total: 0,
    notifications: [],
  }),

  computed: {

    alerts() {
      return _.filter(this.notifications, { 'data': { 'category': 'alert' } });
    },

    events() {
      return _.filter(this.notifications, { 'data': { 'category': 'event' } });
    },

    logs() {
      return _.filter(this.notifications, { 'data': { 'category': 'log' } });
    },

    hasUnread() {
      const unread = this.total > 0;
      const el = $('#notification_pulse');
      if (unread) {
        el.addClass('kt-pulse__ring');
      } else {
        el.removeClass('kt-pulse__ring');
      }
      return unread;
    },
  },

  mounted() {
    this.fetch();

    if (window.Echo) {
      this.listen();
    }

    this.initDropdown();
  },

  methods: {

    /**
     * Fetch notifications.
     *
     * @param {Number} limit
     */
    fetch(limit = 100) {
      axios.get('/notifications', { params: { limit } })
        .then(({ data: { total, notifications } }) => {
          this.total = total;
          this.notifications = notifications.map(({ id, data, created }) => ({
            id: id,
            data: data.data,
            created: created,
          }));
        }).catch((err) => {
          this.handleAxiosError(err);
        });
    },

    /**
     * Mark the given notification as read.
     *
     * @param {Object} notification
     */
    markAsRead({ id }) {
      const index = this.notifications.findIndex(n => n.id === id);

      if (index > -1) {
        this.total--;
        this.notifications.splice(index, 1);
        axios.patch(`/notifications/${id}/read`);
      }
    },

    /**
     * Mark all notifications as read.
     */
    markAllRead() {
      this.total = 0;
      this.notifications = [];

      axios.post('/notifications/mark-all-read');
    },

    /**
     * Listen for Echo push notifications.
     */
    listen() {
      window.Echo.private(`App.Models.User.${window.Laravel.user.id}`)
        .notification((notification) => {
          this.total++;
          this.notifications.unshift(notification);
          if (notification.data.toastr) {
            toastr[notification.data.toastr.type || 'info'](notification.data.title);
          }
          if (notification.data.emit) {
            EventBus.$emit(notification.data.emit);
          }
        })
        .listen('NotificationRead', ({ notification_id }) => {
          this.total--;
          const index = this.notifications.findIndex(n => n.id === notification_id);
          if (index > -1) {
            this.notifications.data.splice(index, 1);
          }
        })
        .listen('NotificationReadAll', () => {
          this.total = 0;
          this.notifications = [];
        })
        .listen('.scheduler_recording_started', (notification) => {
          this.notifyRecStart(notification);
        }).listen('.scheduler_recording_added_to_platform', (notification) => {
          this.notifyRecStop(notification);
        });
    },

    async notifyRecStart(notification) {
      await axios.post("/api/v1/notifications", {
        legacy_id: notification.userid, // aka legacy_id
        notification: 'GenericNotification',
        data: {
          title: `${notification.streamname} started`,
          body: notification.showname,
          action_url: '#',
          category: 'event',
          icon: notification.image || '/build/media/logo/logo_timbre.png',
          toastr: {
            type: 'success',
          },
        },
      });
    },

    async notifyRecStop(notification) {
      // workaround to display another image if it is a quickrecord it will end with / (or just in case)
      if (notification.attachment.image_url === `https://download-${notification.attachment.author_name}.sharp-stream.com/images/`) {
        notification.attachment.image_url = '/build/media/logo/logo_timbre.png';
      }
      await axios.post("/api/v1/notifications", {
        legacy_id: notification.userid, // aka legacy_id
        notification: 'GenericNotification',
        data: {
          title: `${notification.streamname} is ready!`,
          body: notification.filename,
          action_url: notification.attachment.title_link,
          category: 'event',
          icon: notification.attachment.image_url,
          toastr: {
            type: 'success',
          },
        },
      });
    },

    /**
     * Initialize the notifications dropdown.
     */
    initDropdown() {
      const dropdown = $(this.$refs.dropdown);

      $(document).on('click', (e) => {
        if (!dropdown.is(e.target) && dropdown.has(e.target).length === 0 &&
          !$(e.target).parent().hasClass('notification-mark-read')) {
          dropdown.removeClass('open');
        }
      });
    },

    /**
     * Toggle the notifications dropdown.
     */
    toggleDropdown() {
      $(this.$refs.dropdown).toggleClass('open');
    },
  },
};
</script>

<style lang="scss">

  .toolbar-notifications-tab {
    .notification__item-body {
      white-space: pre-line;
    }

    .kt-notification__item-icon {
      img {
        height: 75px;
      }
    }
    ul {
      padding-inline-start: 0;
    }
  }

  .title {
    margin-right: 1em;
  }

</style>
